import { Utils } from '@lightningjs/sdk';
import lng from '@lightningjs/core';

export default class SplashScreenComponent extends lng.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      collision: true,
      Logo: {
        src: Utils.asset('images/logo.png'),
        mount: 0.5,
        x: 960,
        y: 400,
      },
      Spinner: {
        texture: lng.Tools.getSvgTexture(Utils.asset('images/spinner.svg'), 80, 80),
        w: 80,
        h: 80,
        mount: 0.5, // center the anchor point
        x: 960, // half of typical full HD screen width
        y: 540, // half of typical full HD screen height
        rotation: 0, // initial rotation
      },
    };
  }

  _init() {
    this._spin();
  }

  _spin() {
    this.tag('Spinner')
      .animation({
        duration: 2, // animation duration in seconds
        repeat: -1, // repeat indefinitely
        actions: [
          { p: 'rotation', v: { 0: 0, 1: 10 * Math.PI } }, // rotate 360 degrees
        ],
      })
      .start();
  }

  _handleHover() {
    return true;
  }
}
